// components/InvoiceDocument.js
import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { LogoEn } from "../../styled/AllImages";
import { useTranslation } from "react-i18next";
import TheSans from "../../../assets/fonts/arabic/TheSans-Plain.ttf"

Font.register({
  family: "sans",
  src: TheSans,
});

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 14,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 20,
    marginTop: 20,
  },
  invoiceTitle: {
    color: "#38D200",
    fontSize: 32,
    fontWeight: "bold",
  },
  logo: {
    width: 150,
    height: 40,
    objectFit: "contain",
  },
  topRightBlock: {
    fontSize: 14,
    lineHeight: 1.6,
  },
  labelText: {
    fontWeight: "bold",
    color: "#0473EA",
  },
  section: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 30,
    gap: 20,
  },
  column: {
    width: "100%",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#0473EA",
    color: "#fff",
    padding: 10,
    fontSize: 14,
    fontWeight: "bold",
  },
  row: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #ccc",
    padding: 10,
    fontSize: 14,
  },
  tableCell: {
    flex: 1,
  },
  totalRow: {
    flexDirection: "row",
    backgroundColor: "#0473EA",
    color: "#fff",
    padding: 12,
    marginTop: 20,
    fontSize: 15,
    fontWeight: "bold",
  },
  totalLabel: {
    flex: 3,
    // textAlign: "right",
    paddingRight: 10,
  },
  totalValue: {
    flex: 1,
    // textAlign: "right",
  },
});

const InvoiceDocument = ({ data }) => {
  const {
    invoiceNum,
    totalAmount,
    bankName,
    iban,
    beneficiaryName,
    userName,
    planInfo,
    numOfLicenses,
  } = data;
  const { t, i18n: {language} } = useTranslation();

  const today = new Date().toLocaleDateString();

  return (
    <Document>
      <Page size="A4" style={{...styles.page, fontFamily: language === "en" ? "Helvetica" : "sans"}}>
        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.invoiceTitle}>{t("invoice")}</Text>
          <View style={styles.topRightBlock}>
            <Image src={LogoEn} style={styles.logo} />
            <Text style={{marginTop: 10}}>
              <Text style={styles.labelText}>{t("date")}:</Text> {today}
            </Text>
            <Text>
              <Text style={styles.labelText}>{t("invoice_no")}:</Text> {invoiceNum}
            </Text>
          </View>
        </View>

        {/* Section: Bank & User Info */}
        <View style={styles.section}>
          <View style={styles.column}>
            <Text style={{marginBottom: 5}}>
              <Text style={styles.labelText}>{t("bank_name")}:</Text> {bankName}
            </Text>
            <Text style={{marginBottom: 5}}>
              <Text style={styles.labelText}>{t("beneficiary_name")}:</Text>{" "}
              {beneficiaryName}
            </Text>
            <Text style={{marginBottom: 5}}>
              <Text style={styles.labelText}>{t("iban")}:</Text> {iban}
            </Text>
          </View>
        </View>
        <View style={{...styles.row, marginBottom: 20}}>
          <View>
            <Text style={{ ...styles.labelText, marginBottom: 5, fontWeight: "bold" }}>
              {t("from")}:
            </Text>
            <Text>{t("cloud_archive")}</Text>
          </View>
          <View>
            <Text style={{ ...styles.labelText, fontWeight: "bold", marginBottom: 5 }}>
              {t("to")}:
            </Text>
            <Text>{userName}</Text>
          </View>
        </View>

        {/* Table Header */}
        <View style={styles.tableHeader}>
          <Text style={[styles.tableCell, { flex: 2 }]}>
            {t("description")}
          </Text>
          <Text style={styles.tableCell}>{t("price")}</Text>
          <Text style={styles.tableCell}>{t("total")}</Text>
        </View>

        {/* Table Row */}
        <View style={styles.tableRow}>
          <Text style={[styles.tableCell, { flex: 2 }]}>{planInfo?.title} {planInfo?.duration == 12 ? t("annually") : t("monthly")}</Text>
          <Text style={styles.tableCell}>{planInfo?.amount}</Text>
          <Text style={styles.tableCell}>
            {totalAmount} {t("usd")}
          </Text>
        </View>

        {/* Total Amount */}
        <View style={styles.totalRow}>
          <Text style={styles.totalLabel}>{t("total_amount")}</Text>
          <Text style={styles.totalValue}>
            {totalAmount} {t("usd")}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default InvoiceDocument;

// // components/InvoiceDocument.js
// import React from "react";
// import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
// import { Table, TableRow, TableCell } from "@ag-media/react-pdf-table";

// const styles = StyleSheet.create({
//   page: {
//     padding: 30,
//     fontSize: 12,
//   },
//   title: {
//     fontSize: 20,
//     marginBottom: 20,
//     textAlign: "center",
//   },
// });

// const InvoiceDocument = ({ data }) => {
//   const { invoiceNum, totalAmount, bankName, iban, beneficiaryName, userName } = data;

//   const tableData = [
//     { label: "Invoice Number", value: invoiceNum },
//     { label: "Total Amount", value: totalAmount },
//     { label: "Bank Name", value: bankName },
//     { label: "IBAN", value: iban },
//     { label: "Beneficiary", value: beneficiaryName },
//   ];

//   return (
//     <Document>
//       <Page size="A4" style={styles.page}>
//         <Text style={styles.title}>Payment Invoice</Text>

//         <View>
//           <Text>User: {userName}</Text>
//           <Text>Date: {new Date().toLocaleDateString()}</Text>
//         </View>

//         <Table data={tableData}>
//           <TableRow>
//             <TableCell weight={1}>Label</TableCell>
//             <TableCell weight={2}>Value</TableCell>
//           </TableRow>

//           {tableData.map((row, index) => (
//             <TableRow key={index}>
//               <TableCell>{row.label}</TableCell>
//               <TableCell>{row.value}</TableCell>
//             </TableRow>
//           ))}
//         </Table>
//       </Page>
//     </Document>
//   );
// };

// export default InvoiceDocument;
